import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'ngf-reload-app-dialog',
    templateUrl: './reload-app-dialog.component.html',
    styleUrls: ['./reload-app-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ReloadAppDialogComponent {

  constructor() { }

  reload() {
    window.location.reload();
  }

}
